export const getAgencyDisplayName = (name: string, postalCode: string | null | undefined) =>
  postalCode ? `${name} (${postalCode})` : name;
